import { toast } from "react-toastify";
import { resolveNotice } from "../api/notificationInbox";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

// Social notices (likes, comments, follows, lives, orders...) have no inbox group. They keep the website's old redirect rules,
// which are moved here unchanged from the old notification list so the inbox and the bell share them.
export function socialRedirect(notification, navigate) {
  switch (notification.key) {
    case "postKey":
    case "postLikeKey":
    case "postCommentKey":
      navigate(`/post/${notification.notification_id}`);
      return true;

    case "commentLikeKey":
    case "commentReplyKey":
      navigate(`/post/${notification.notification_id}#comments`);
      return true;

    case "friendKey":
      navigate("/profilefollowers");
      return true;

    case "storyKey":
    case "storyLikeKey":
    case "storyCommentKey":
    case "storyTagKey":
      navigate(`/story/${notification.notification_id}`);
      return true;

    case "groupKey":
      navigate("/groupsfamily");
      return true;

    case "donationKey":
      navigate(`/donation/${notification.notification_id}`);
      return true;

    case "subscriptionKey":
    case "subscriptionReminderKey":
      navigate("/subscription");
      return true;

    case "goLiveKey": {
      // notification_id is the live's numeric id; the viewer page needs its stream_id
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      fetch(`${API_BASE_URL}/live/status/${notification.notification_id}`, { headers: { token } })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) navigate(`/stream/${data.result.stream_id}`);
          else toast.error(data.message || "This live is no longer available");
        })
        .catch(() => toast.error("Unable to open this live"));
      return true;
    }

    default:
      // Notices from the newer notification system have no "key": match on the title or type instead.
      if (notification.title === "Family Wallet invite") {
        navigate("/wallet");
        return true;
      }
      if (notification.type === "order_update" || notification.type === "delivery_status") {
        navigate("/myorder");
        return true;
      }
      return false;
  }
}

// Opens what a notice is about. Returns { opened: true } or { opened: false, message } when the thing it points at is gone
// (shown as a short "no longer available" line, never an error page) or the notice has nowhere to go.
export async function openNotice(item, navigate) {
  if (!item.group && !item.link) {
    return { opened: socialRedirect(item, navigate) };
  }
  if (!item.link) return { opened: false, message: "" };
  try {
    const result = await resolveNotice(item.id);
    if (!result.available) return { opened: false, message: result.message || "This is no longer available." };
    navigate(result.link || item.link);
    return { opened: true };
  } catch (e) {
    // The check could not run (network). Go to the link anyway: the page itself shows its own "not found" state.
    navigate(item.link);
    return { opened: true };
  }
}
